import React from "react";

import { Catalog as CatalogType } from "resources/AudiotekaApi";

import CategoryList from "./components/category-list/category-list";
import ItemSets from "./components/item-sets/item-sets";
import css from "./catalog.module.scss";

function Catalog({ catalog }: { catalog: CatalogType }) {
  return (
    <div className={css.catalog}>
      {catalog._embedded["app:screen-section"].map((section) => {
        switch (section.type) {
          case "category-list":
            return <CategoryList title={section.title} key={section.id} section={section} />;
          case "item-sets":
            return <ItemSets key={section.id} sets={section.elements} />;
          default:
            return null;
        }
      })}
    </div>
  );
}

export default Catalog;
